// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_USERS_DIRECTORY = "N\u00e1jdi mami\u010dku";
export const USERS_DIRECTORY_SEARCH = "H\u013eadaj";
